import React from 'react';
import { GridTable } from '@ctsu/ctsu-mui-grid';
import { RenderControl } from 'components/RenderHelpers';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { createLoadingSelector, createErrorMessageSelector } from 'selectors';
import PropTypes from 'prop-types';
import { PRT_DETAIL_ACTIONS } from 'actions/protocols/protocoldetail';
import { getTableColumns, GetUserFullName } from 'helpers';
import { TE } from 'appconstants';

const loadingSelector = createLoadingSelector([
  PRT_DETAIL_ACTIONS.GET_PROT_STATUS_HIST
]);
const errorSelector = createErrorMessageSelector([
  PRT_DETAIL_ACTIONS.GET_PROT_STATUS_HIST
]);


const ChangeHistoryColumns = [
  ['actionDate', 'string', 'Change Date', 'left', true],
  ['from', 'string', 'From Status', 'left', true],
  ['to', 'string', 'To Status', 'left', true],
  ['comments', 'string', 'Reason', 'left', true],
  // ['fromAccuralTarget', 'string', 'From Accural Target', 'left', true],
  ['value', 'string', 'Accural Target Update', 'left', true],
  ['fullName', 'string', 'Changed By', 'left', true]
];

const StrataHistory = ({ data }) => (
  <GridTable
    tag={`${TE.ID}StrataChangeHistory${TE.TABLE}`}
    user={GetUserFullName()}
    columns={getTableColumns(ChangeHistoryColumns)}
    rows={data}
    filterable
    sortable
    enableToolbar
    recordPerPage={10}
    toPdf={false}
  />
);

StrataHistory.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object])
};

StrataHistory.defaultProps = {
  data: null
};

export { StrataHistory };

const prtStrataChangeHistory = props => {
  const { strataHistData, isLoading, iserror } = props;
  return (
    <RenderControl
      isLoading={isLoading}
      iserror={iserror}
      compName="Strata Change History"
      permission
    >
      <StrataHistory data={strataHistData} />
    </RenderControl>
  );
};

prtStrataChangeHistory.propTypes = {
  isLoading: PropTypes.bool,
  iserror: PropTypes.bool
  // prtStatusChangeHist: PropTypes.oneOfType([PropTypes.object])
};

prtStrataChangeHistory.defaultProps = {
  isLoading: false,
  iserror: false
  // prtStatusChangeHist: null
};

const withConnectState = connect((state, ownProps) => ({
  strataHistData: state.prtDetails.strataHistory,
  isLoading: loadingSelector(state),
  iserror: errorSelector(state)
}));

const StrataChangeHistory = compose(withConnectState)(prtStrataChangeHistory);
export default StrataChangeHistory;
